import * as R from 'ramda';
import React from 'react';
import { Formik } from 'formik';
import { Button, ModalBody, ModalFooter } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import FormButtonGroup from 'App/components/styles/FormButtonGroup';
import SubmitButton from 'Shared/form/SubmitButton';
import { TextField } from 'Shared/form/TextField';
import useCreateProtocolTemplateMutation from 'App/hooks/useCreateProtocolTemplateMutation';
import { useBuilderContext } from '../BuilderContext';

const propTypes = {};

const defaultProps = {};

function CreateTemplateForm() {
    const { setShowCreateModal } = useBuilderContext();
    const navigate = useNavigate();

    const createProtocolTemplateMutation = useCreateProtocolTemplateMutation();

    return (
        <Formik
            initialValues={{ name: '' }}
            onSubmit={(values) => {
                return createProtocolTemplateMutation
                    .mutateAsync(values)
                    .then(({ uuid }) => navigate(`/protocol-template-builder/template/${uuid}`));
            }}
        >
            {({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                    <ModalBody>
                        <TextField fieldName="name" required label="Template Name" placeholder="Template Name" />
                    </ModalBody>
                    <ModalFooter>
                        <FormButtonGroup>
                            <Button variant="outline-secondary" type="button" onClick={() => setShowCreateModal(R.F)}>
                                Cancel
                            </Button>
                            <SubmitButton>Create</SubmitButton>
                        </FormButtonGroup>
                    </ModalFooter>
                </form>
            )}
        </Formik>
    );
}

CreateTemplateForm.propTypes = propTypes;
CreateTemplateForm.defaultProps = defaultProps;

export default CreateTemplateForm;
